<template>
  <modal :title='$t(title)' :visible.sync='isShowDialog' width='600px'>
    <!-- label-width 自适应：中英文 label 均不换行 -->
    <el-form ref='form' :model='dioForm' class='unit-setting-form'>
      <el-form-item :label="$t('integration.temp_unit')" prop='tempUnit'>
        <el-select v-model='dioForm.tempUnit' style='width: 250px' :placeholder="$t('integration.please_select')">
          <el-option
            v-for='item in tempUnitOptions'
            :key='item.value'
            :label='item.label'
            :value='item.value'>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot='footer'>
      <el-button type='primary' @click='isShowDialog = false'>{{ $t('public.btn_close') }}</el-button>
      <el-button type='primary' @click='handleSave'>{{ $t('public.btn_confirm') }}</el-button>
    </div>
  </modal>
</template>

<script>
import { saveUnitSetting, getUnitSetting } from '@/api/modules/material.js'

export default {
  props: ['isShowUnit', 'title'],
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowUnit
      },
      set: function (val) {
        this.$emit('update:isShowUnit', val)
      }
    }
  },
  data () {
    return {
      dioForm: {
        tempUnit: ''
      },
      tempUnitOptions: [
        {
          label: this.$t('integration.celsius'),
          value: '°C'
        },
        {
          label: this.$t('integration.fahrenheit'),
          value: '°F'
        },
        {
          label: this.$t('integration.kelvin'),
          value: 'K'
        }
      ]
    }
  },
  watch: {
    isShowDialog (newVal) {
      if (newVal) {
        this.getTempUnitList()
        this.clearValidate()
      }
    }
  },
  methods: {
    getTempUnitList () {
      getUnitSetting().then((res) => {
        if (res.result) {
          res.result.forEach(item => {
            if (item.code === 'temp') {
              this.dioForm.tempUnit = item.name
            }
          })
        }
      }).catch((err) => {
        console.error('获取温度单位失败', err)
      })
    },

    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    async justify () {
      try {
        return await this.$refs['form'].validate()
      } catch (error) {
        return false
      }
    },
    async handleSave () {
      let flag = await this.justify()
      if (!flag) return

      let data = [
        {
          code: 'temp',
          value: this.dioForm.tempUnit
        }
      ]

      saveUnitSetting(data).then(({
        result,
        state
      }) => {
        if (result === 200) {
          this.$message.success(this.$t('integration.successfully_modified'))
          this.isShowDialog = false // 保存成功后建议自动关闭弹框
        } else {
          this.$message.error(state.msg)
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.unit-setting-form {
  display: flex;
  flex-direction: column;
  align-items: center;

  ::v-deep .el-form-item {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }

  ::v-deep .el-form-item__label {
    white-space: nowrap;
  }
}
</style>
